import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { CreateSigningAppointmentFormData } from '../../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { AddNotaryLaterButton } from './NotesForm/AddNotaryLaterButton';
import { Show } from 'components/shared/Show';
import { eSigningMethod } from 'types/signingAppointment/eSigningMethod';
import { css } from '@/styled-system/css';
import { Button } from '@zillow/constellation-10';

export const NotesNavigation: React.FC<{
  advance: () => void;
  goBack: () => void;
  updatedWizardFormData: CreateSigningAppointmentFormData;
  setUpdatedWizardFormData: React.Dispatch<React.SetStateAction<CreateSigningAppointmentFormData>>;
  isDigSync?: boolean;
}> = ({ advance, goBack, updatedWizardFormData, setUpdatedWizardFormData, isDigSync }) => {
  const { isValid } = useFormikContext();
  const shouldDisableNextButton = useMemo(
    () => !isValid && updatedWizardFormData.signingMethod !== eSigningMethod.wetSign,
    [isValid, updatedWizardFormData.signingMethod]
  );

  return (
    <section
      className={css({ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingTop: '16' })}
    >
      <Button tone={'brand'} emphasis={'outlined'} size="sm" onClick={goBack}>
        Back
      </Button>
      <div className={css({ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '16' })}>
        <Show when={!isDigSync}>
          <AddNotaryLaterButton
            advance={advance}
            updatedWizardFormData={updatedWizardFormData}
            setUpdatedWizardFormData={setUpdatedWizardFormData}
          />
        </Show>
        <Button tone={'brand'} emphasis={'filled'} size="sm" type="submit" disabled={shouldDisableNextButton}>
          Next
        </Button>
      </div>
    </section>
  );
};
